import React from 'react';
import { XIcon } from 'lucide-react';
const pains = ['Losing three hours every Sunday night programming the week', 'Staring at a blank page trying to invent "one more" workout', 'A downloads folder full of workout packs you never open', 'Running the same five circuits because there was no time to plan new ones', 'A brand-new client and a two-year regular in the same class', 'It rains, the park is closed, and the session falls apart', 'The kettlebells didn’t make it and your plan depended on them', 'Clients drifting away because every class starts to feel the same'];
export function PainGrid() {
  return <section aria-labelledby="pain-heading" className="w-full bg-navy-deep" data-id="element-138" data-mp="1bqcr7q9idguv">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-139" data-mp="17paqt63uuyrb">
        <div className="text-center" data-id="element-140" data-mp="363viiicy437q">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-141" data-mp="362u9skjejst6">
            The coaching reality
          </p>
          <h2 id="pain-heading" className="mt-3 font-display font-bold uppercase text-white text-3xl sm:text-4xl md:text-5xl leading-tight" data-id="element-142" data-mp="3231zo3ed1elp">
            If you run bootcamps, you know at least{' '}
            <span className="text-crimson-soft" data-id="element-143" data-mp="378omeublvrio">half of this list.</span>
          </h2>
        </div>

        <ul className="mt-9 grid gap-3 text-left sm:grid-cols-2 sm:gap-x-5" data-id="element-144" data-mp="3b9qnzhszwfnt">
          {pains.map(pain => <li key={pain} className="flex items-start gap-3 rounded-xl border border-navy-line bg-navy-card px-4 py-4 text-sm text-white/85" data-id="element-145" data-mp="2toy3l1r2h0b">
              <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-crimson/20" data-id="element-146" data-mp="3q7j163b2kryu">
                <XIcon className="h-3 w-3 text-crimson-soft" aria-hidden="true" data-id="element-147" data-mp="3u82yb6vn7vkz" />
              </span>
              {pain}
            </li>)}
        </ul>

        <p className="mt-9 text-center font-display uppercase text-2xl sm:text-3xl text-gold leading-tight" data-id="element-148" data-mp="qjrjxjf2mqqh">
          How many more Sunday nights do you want to give away?
        </p>
      </div>
    </section>;
}